import { render, staticRenderFns } from "./ForumResponseEditor.vue?vue&type=template&id=424df07a&scoped=true"
import script from "./ForumResponseEditor.vue?vue&type=script&lang=js"
export * from "./ForumResponseEditor.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseEditor.vue?vue&type=style&index=0&id=424df07a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424df07a",
  null
  
)

export default component.exports